var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyFlash = function SvgHappyFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#happyFlash_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.209 4.667H7.817L10.456.445A.292.292 0 0 0 10.209 0H5.542a.29.29 0 0 0-.283.221l-1.75 7a.292.292 0 0 0 .283.362h1.951l-1.649 6.048a.29.29 0 0 0 .16.342.3.3 0 0 0 .364-.104l5.833-8.75a.29.29 0 0 0-.242-.452"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "happyFlash_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgHappyFlash;